import BasicRedirect from '@/views/routes/components/BasicRedirect';
import BasicRoute from '@/views/routes/components/BasicRoute';
import React from 'react';
import { Switch } from 'react-router-dom';

export interface Routes {
  title?: string;
  path?: string;
  redirect?: boolean;
  from?: string;
  to?: string;
  exact?: boolean;
  component?: any;
  children?: Routes[];
}

export default function renderRoutes(routes: Routes[]) {
  return (
    routes?.map((route) => {
      const { children, path, redirect, from, to, exact, ...rest } = route;

      if (children && children.length) {
        return (
          <BasicRoute path={path} key={path} exact={exact} {...rest}>
            <Switch>{renderRoutes(children)}</Switch>
          </BasicRoute>
        );
      }
      if (redirect) {
        return <BasicRedirect from={from} to={to} key={`redirect-${to}`} exact={exact} {...rest} />;
      }

      return <BasicRoute path={path} key={path} {...rest} />;
    }) ?? []
  );
}
